export default "__VITE_ASSET__CelFewLi__"